import { AdmittedSessionPanel } from '../../components/custodian/AdmittedSessionPanel';

export function CustodianAssetRegisterPage() {
  return (
    <div className="page-stack">
      <AdmittedSessionPanel />
    </div>
  );
}
